function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SVGIcon } from '@homeaway/react-svg';
import { MINUS__12, MINUS__16, CHECK__12, CHECK__16 } from '@homeaway/svg-defs';
import classNames from 'classnames';
import "./CheckRadioBase.css";
/**
 * CheckRadioBase
 *
 * This is the base component for RadioButtons and Checkboxes.
 */

var CheckRadioBase = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CheckRadioBase, _Component);

  function CheckRadioBase(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = CheckRadioBase.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.input) {
      this.input.indeterminate = this.props.indeterminate;
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.indeterminate !== this.props.indeterminate) {
      this.input.indeterminate = this.props.indeterminate;
    }
  };

  _proto.render = function render() {
    var _classNames,
        _classNames2,
        _classNames3,
        _this = this;

    var _this$props = this.props,
        label = _this$props.label,
        labelPosition = _this$props.labelPosition,
        checked = _this$props.checked,
        type = _this$props.type,
        error = _this$props.error,
        className = _this$props.className,
        inline = _this$props.inline,
        size = _this$props.size,
        children = _this$props.children,
        onChange = _this$props.onChange,
        onMouseUp = _this$props.onMouseUp,
        onTouchEnd = _this$props.onTouchEnd,
        indeterminate = _this$props.indeterminate,
        rest = _objectWithoutProperties(_this$props, ["label", "labelPosition", "checked", "type", "error", "className", "inline", "size", "children", "onChange", "onMouseUp", "onTouchEnd", "indeterminate"]);

    var parentClasses = classNames(className, (_classNames = {
      'form-group': true,
      CRB: true
    }, _classNames["CRB--" + type] = true, _classNames['CRB--inline'] = inline, _classNames["CRB--" + size] = size, _classNames['has-error'] = !!error, _classNames['CRB--disabled'] = !!this.props.disabled, _classNames));
    var inputClasses = classNames('CRB__input', (_classNames2 = {}, _classNames2['CRB__input--error'] = !!error, _classNames2));
    var labelClasses = classNames('CRB__label', 'text-muted', (_classNames3 = {}, _classNames3['CRB__label--error'] = !!error, _classNames3['CRB__label--top'] = labelPosition === 'top', _classNames3['CRB__label--bottom'] = labelPosition === 'bottom', _classNames3['CRB__label--right'] = labelPosition === 'right', _classNames3));
    var toggleClasses = classNames('CRB__toggle', {
      'CRB__toggle--left': labelPosition === 'right',
      'CRB__toggle--center': labelPosition === 'top' || labelPosition === 'bottom'
    });
    return /*#__PURE__*/React.createElement("div", {
      className: parentClasses,
      onTouchEnd: onTouchEnd,
      onMouseUp: onMouseUp
    }, /*#__PURE__*/React.createElement("label", {
      className: labelClasses
    }, /*#__PURE__*/React.createElement("input", _extends({
      ref:
      /* istanbul ignore next */
      function ref(e) {
        _this.input = e;
      },
      type: type,
      className: inputClasses
    }, rest, {
      checked: checked,
      onChange: onChange
    })), /*#__PURE__*/React.createElement("span", {
      className: toggleClasses
    }, type === 'checkbox' && !indeterminate && this.props.checked && /*#__PURE__*/React.createElement(SVGIcon, {
      inlineFlex: true,
      className: "CRB__svg",
      markup: size === 'sm' ? CHECK__12 : CHECK__16
    }), type === 'checkbox' && indeterminate && /*#__PURE__*/React.createElement(SVGIcon, {
      inlineFlex: true,
      className: "CRB__svg",
      markup: size === 'sm' ? MINUS__12 : MINUS__16
    })), /*#__PURE__*/React.createElement("span", {
      className: "label-text"
    }, label)), children);
  };

  return CheckRadioBase;
}(Component);

CheckRadioBase.propTypes = {
  /** Text label, can also contain other content if you need it. */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /** Text label position */
  labelPosition: PropTypes.oneOf(['top', 'bottom', 'right']),

  /** Mark the component as checked */
  checked: PropTypes.bool,

  /** If you intend to use these inline (horizontal). */
  inline: PropTypes.bool,

  /** Set to true to turn it red, such as when it is required */
  error: PropTypes.bool,

  /** Size variation. Default is 24px width/height; 'sm' will change both to 16px */
  size: PropTypes.oneOf(['sm']),

  /** Called when the checked property changes */
  onChange: PropTypes.func,

  /** Ignore, part of the base component */
  type: PropTypes.oneOf(['radio', 'checkbox'])
};
CheckRadioBase.defaultProps = {
  labelPosition: 'right',
  onChange: function onChange() {}
};
export default CheckRadioBase;
//# sourceMappingURL=CheckRadioBase.js.map